import React, { Component } from "react";
import styles from "./stylesheets/about.module.css";
import { Grid, Row, Col } from "react-bootstrap";
import badge from "./images/superlawyers.png";
import "./stylesheets/bootstrap/css/bootstrap.css";

class About extends Component {
  render() {
    return (
      <div className={styles.about + " " + styles.jumptarget} id="about">
        <Grid>
          <h1>ABOUT JOSHUA ANNENBERG, ESQ.</h1>
          <div className={styles.line}></div>
          <Row>
            <Col md={8} className={styles.about_body}>
              <p>
                Joshua Annenberg, Esq., serves as Appellate & Motion Counsel to
                the plaintiffs’ personal injury and medical malpractice bar.
                When you must win an appeal or summary judgment motion in a
                complex, high-value action, retaining experienced and effective
                Appellate and Motion counsel is imperative. Joshua Annenberg,
                Esq., is recognized by the plaintiffs’ bar for his proven record
                of success on appeal and in defeating complex summary judgment
                motions.
              </p>
              <p>
                Joshua Annenberg’s extensive experience as Appellate & Motion
                Counsel includes actions brought pursuant to Labor Law 240(1)
                and 241(6), medical malpractice and nursing home
                negligence/malpractice, product liability, premises liability,
                motor vehicle negligence, wrongful death and municipal/special
                relationship matters. Additionally, Joshua Annenberg serves as
                Appellate Counsel in criminal cases.
              </p>
              <p>
                Incisive legal writing and analysis are a hallmark of Joshua
                Annenberg’s appellate briefs and summary judgment motion papers.
                His significant legal victories for the plaintiffs’ bar
                ultimately benefit attorneys of record and their clients with
                exceptional monetary recoveries.
              </p>
              <p>
                Joshua Annenberg, Esq. has been named to Super Lawyers since
                2016 in the Appellate Practice section. He graduated from
                Benjamin N. Cardozo School of Law in 1993 and served as an
                Adjunct Professor of Law for Legal Writing at New York Law
                School from 2005 through 2010.
              </p>
              <p className={styles.disclaimer}>
                Attorney Advertising. Past results do not guarantee future
                outcomes.
              </p>
            </Col>
            <Col md={4} className={styles.image}>
              <div>
                <img src={badge} alt="Super lawyers badge"></img>
              </div>
            </Col>
          </Row>
          {/*<div data-slbadge="v1-slbadge-gray" data-text1="Selected in 2018" data-text2="Thomson Reuters" style="width:180px;height:150px;border-radius:12px;font-family:arial, sans-serif;color:gray;text-align:center"><script async type="text/javascript" src="https://www.superlawyers.com/static/sl-badge/v1/load.min.js"></script><a class="slbadge_profileurl" title="View the profile of New York Metro Appellate Attorney Joshua Annenberg" href="https://profiles.superlawyers.com/new-york-metro/new-york/lawyer/joshua-annenberg/4f95df09-49f0-446e-ad09-412d54223b9f.html?utm_source=4f95df09-49f0-446e-ad09-412d54223b9f&utm_campaign=v1-slbadge-gray&utm_content=profile">Joshua Annenberg</a><div style="margin-top:6px">Rated by Super Lawyers<br /><br /><br />loading ...</div></div>*/}
        </Grid>
      </div>
    );
  }
}

export default About;
